import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  standalone: false,
  selector: 'lib-toast',
  template: `
    <div class="notification">
      <mat-icon *ngIf="data?.icon">{{ data?.icon }}</mat-icon> {{ data.message }}
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .notification {
        display: flex;
        align-items: center;
      }
      .notification mat-icon {
        margin-right: 10px;
      }
    `
  ]
})
export class ToastComponent implements OnInit {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data) {}

  ngOnInit(): void {}
}
